export default __webpack_public_path__ + "static/media/honey.e7882140.png";